import toggleNavImg from "../static/images/navbarToggler.png";
import React from "react";
import ombreHeading from "../static/images/ombre-white-full.svg";

function Header({ page }) {
  return (
    <div className="header">
      <nav className="navbar navbar-expand-md navbarContainer navbar-dark py-xl-1 py-lg-1 py-md-1 py-sm-3 py-3">
        <a href="/#">
          <div className="ombreHeading pl-xl-7 pl-lg-6 pl-md-5">
            <img src={ombreHeading} className="ombreHeadingImage" />
          </div>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#collapsibleNavbar"
        >
          <img src={toggleNavImg} width={24} height={24} alt="Toggle Icon" />
        </button>
        <div className="collapse navbar-collapse" id="collapsibleNavbar">
          <ul className="navbar-nav ml-auto" id="navbarItemsContainer">
            <li className="nav-item pr-xl-5 pr-lg-6 pr-md-5 py-2">
              <a
                className={
                  `nav-link titleHome ` +
                  (page !== "artist" && page !== "contact" ? "active" : "")
                }
                href="/#"
              >
                Home
              </a>
            </li>
            <li className="nav-item pr-xl-5 pr-lg-6 py-2 pr-md-5 pr-md-5">
              <a
                className={
                  `nav-link titleArtists ` + (page === "artist" ? "active" : "")
                }
                href="/artist"
              >
                Artists
              </a>
            </li>
            <li className="nav-item pr-xl-5 pr-lg-6 py-2 pr-md-5 pr-md-5">
              <a
                className={
                  `nav-link titleArtists ` +
                  (page === "contact" ? "active" : "")
                }
                href="/contact"
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/pages/Home/components/Header.jsx